import type { Dispatch, MutableRefObject, ReactNode, SetStateAction } from 'react';
import { createContext, useState } from 'react';

// Types
import type { RowData, Table } from '@tanstack/react-table';
import clsx from 'clsx';

import TableBody from '@/components/base/Table/CompoundTable/TableBody';
import TableFooter from '@/components/base/Table/CompoundTable/TableFooter';
// Components
import TableHeader from '@/components/base/Table/CompoundTable/TableHeader';

export const CompoundTableContext = createContext<{
    table: Table<RowData>;
    columnIdHover: number;
    updateColumnIdHover: Dispatch<SetStateAction<number>>;
}>(undefined);

function CompoundTable<TData extends RowData>({
    table,
    children,
    className,
    tableWrapperRef
}: {
    table: Table<TData>;
    children: ReactNode;
    className?: string;
    tableWrapperRef?: MutableRefObject<HTMLDivElement>;
}) {
    const [columnIdHover, setColumnIdHover] = useState<number>(null);

    return (
        <CompoundTableContext.Provider
            // @ts-ignore
            value={{ table, columnIdHover, updateColumnIdHover: setColumnIdHover }}>
            <div className={clsx('scrollbar rounded-md', className)} ref={tableWrapperRef}>
                <table className="w-full border-separate border-spacing-0 bg-white dark:bg-icoDarkMode-anthracite">
                    {children}
                </table>
            </div>
        </CompoundTableContext.Provider>
    );
}

CompoundTable.Header = TableHeader;
CompoundTable.Body = TableBody;
CompoundTable.Footer = TableFooter;

export default CompoundTable;
